import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { reprogramarRegistro } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';

/**
 * Formulario embebido para reprogramar un Registro del calendario.
 * Props:
 *   - evento: objeto del evento (con id, start, end)
 *   - onExito: callback() cuando se guarda correctamente
 *   - onCancelar: callback() para cancelar sin cambios
 */
const EditarRegistroCalendario = ({ evento, onExito, onCancelar }) => {
  const toInputDate = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    const pad = (n) => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
  };

  const [fechaInicio, setFechaInicio] = useState(toInputDate(evento?.start));
  const [fechaFin, setFechaFin] = useState(toInputDate(evento?.end));
  const [loading, setLoading] = useState(false);

  const handleGuardar = async (e) => {
    e.preventDefault();
    if (!fechaInicio || !fechaFin) {
      Alertassw('warning', 'Ingresa las dos fechas');
      return;
    }
    setLoading(true);
    try {
      await reprogramarRegistro(evento.id, { fechaInicio, fechaFin });
      Alertassw('success', 'Registro reprogramado correctamente');
      onExito();
    } catch (err) {
      Alertassw('error', 'No se pudo reprogramar el registro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleGuardar}>
      <h6 className="fw-bold mb-3">Reprogramar: {evento?.title}</h6>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Fecha inicio</Form.Label>
            <Form.Control
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Fecha fin</Form.Label>
            <Form.Control
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="d-flex gap-2 justify-content-end">
        <Button variant="secondary" onClick={onCancelar} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? 'Guardando…' : 'Guardar'}
        </Button>
      </div>
    </Form>
  );
};

export default EditarRegistroCalendario;
